module.exports = __webpack_public_path__ + "img/icon_sm_xsyycl.cf9548ce.png";